import { mapIndexed } from 'rambdax'
import ZoneSplitBox, {
  ZoneSplitBoxProps,
} from '../components/SplitBox/SplitBox'
import ZoneCardSelector, {
  ZoneCardSelectorProps,
} from './CardSelector/CardSelector'
import ZoneContentWithLogo, {
  ZoneContentWithLogoProps,
} from './ContentWithLogo/ContentWithLogo'
import ZoneFaqBox, { ZoneFaqBoxProps } from './FaqBox/FaqBox'
import ZoneInlineWaitlist, {
  ZoneInlineWaitlistProps,
} from './InlineWaitlist/InlineWaitlist'
import { ZoneLogoList, ZoneLogoListProps } from './LogoList/LogoList'
import ZoneProductFeatureBlockList, {
  ZoneProductFeatureBlockListProps,
} from './ProductFeatureBlockList/ProductFeatureBlockList'
import ZoneProductFeatureBoxList, {
  ZoneProductFeatureBoxListProps,
} from './ProductFeatureBoxList/ProductFeatureBoxList'
import ZoneBigFeatureBlock, {
  ZoneBigFeatureBlockProps,
} from './BigFeatureBlock/BigFeatureBlock'
import ZoneFreeText, { ZoneFreeTextProps } from './FreeText/FreeText'
import ZoneButtonList, { ZoneButtonListProps } from './ButtonList/ButtonList'
import ZoneSubbanner, { ZoneSubbannerProps } from './Subbanner/Subbanner'
import ZoneHomeBoxes, { ZoneHomeBoxesProps } from './HomeBoxes/HomeBoxes'
import ZoneFeatureContainerBlock, {
  ZoneFeatureContainerBlockProps,
} from './FeatureContainerBlock/FeatureContainerBlock'
import ZoneFeatureFullImage, {
  ZoneFeatureFullImageProps,
} from './FeatureFullImage/FeatureFullImage'
import ZoneProductFeatureBlockFullImage, { ZoneProductFeatureBlockFullImageProps } from './ProductFeatureBlockFullImage/ProductFeatureBlockFullImage'
import ZoneBorderlessPlan, { ZoneBorderlessPlanProps } from './BorderlessPlan/BorderlessPlan'

export type ZoneItemType =
  | ZoneProductFeatureBlockListProps
  | ZoneProductFeatureBoxListProps
  | ZoneFaqBoxProps
  | ZoneCardSelectorProps
  | ZoneLogoListProps
  | ZoneSplitBoxProps
  | ZoneInlineWaitlistProps
  | ZoneContentWithLogoProps
  | ZoneBigFeatureBlockProps
  | ZoneFreeTextProps
  | ZoneButtonListProps
  | ZoneSubbannerProps
  | ZoneHomeBoxesProps
  | ZoneFeatureContainerBlockProps
  | ZoneFeatureFullImageProps
  | ZoneProductFeatureBlockFullImageProps
  | ZoneBorderlessPlanProps

export type FeaturesZoneRendererProps = {
  zones: ZoneItemType[]
}

export function getComponentByZoneType(zone: ZoneItemType, key: string) {
  switch (zone.__typename) {
    case 'StrapiGQL_ComponentZonesProductFeatureBlockList':
      return <ZoneProductFeatureBlockList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesProductFeatureBoxList':
      return <ZoneProductFeatureBoxList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesLogoList':
      return <ZoneLogoList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesSplitBox':
      return <ZoneSplitBox key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesFaqBox':
      return <ZoneFaqBox key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesCardSelector':
      return <ZoneCardSelector key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesInlineWaitlist':
      return <ZoneInlineWaitlist key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesContentWithLogo':
      return <ZoneContentWithLogo key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesBigFeatureBlock':
      return <ZoneBigFeatureBlock key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesFreeText':
      return <ZoneFreeText key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesButtonList':
      return <ZoneButtonList key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesSubbanner':
      return <ZoneSubbanner key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesHomeBoxes':
      return <ZoneHomeBoxes key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesFeatureContainerBlock':
      return <ZoneFeatureContainerBlock key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesFeatureFullImage':
      return <ZoneFeatureFullImage key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesProductFeatureBlockFullImage':
      return <ZoneProductFeatureBlockFullImage key={key} {...zone} />
    case 'StrapiGQL_ComponentZonesBorderlessPlan':
      return <ZoneBorderlessPlan key={key} {...zone} />
    default:
      return null
  }
}
export default function FeaturesZoneRenderer({
  zones,
}: FeaturesZoneRendererProps) {
  return (
    <main>
      {mapIndexed(
        (zone, index) =>
          getComponentByZoneType(zone, `${zone.__typename}-${index}`),
        zones
      )}
    </main>
  )
}
